import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';

import { MAIN_DOMAIN } from '@app/app.constants';
import { Lesson, LessonPrivilegeSetting, Pupil, StudentPrivilegeSetting } from '@df/interfaces';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { AbsentService } from '@app/core/services/absent.service';
import { PrivilegeService } from '@app/core/services/privilege.service';
import { smoothScrollToTop } from '@app/_utils/helpers';

@Component({
    selector: 'app-class',
    templateUrl: './class.component.html',
    styleUrls: ['./class.component.scss']
})
export class ClassComponent implements OnInit, OnDestroy {
    @Input() privilegeSettings: LessonPrivilegeSetting[] = [];
    @Input() isTeach: boolean;
    @Input() students: Array<Pupil> = [];
    @Input() lesson: Lesson;
    @Input() selectedStudentIndex: number;
    @Output() selectPupil = new EventEmitter<number>();
    public showPupilInfo: number = null;
    public selectedStudent: Pupil = null;
    public setPrivilege: boolean = false;
    public studentsPrivileges: Array<StudentPrivilegeSetting> = [];
    public main_domain = MAIN_DOMAIN;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private privSvc: PrivilegeService, private absentService: AbsentService) {}

    public ngOnInit(): void {
        if (this.lesson) {
            this.privSvc
                .getStudentsPrivilegeSettingsForLesson(this.lesson.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe((response: any) => {
                    if (response.count > 0) {
                        this.studentsPrivileges = response.results;
                    }
                });
            this.absentService.addedToAbsent.subscribe((studentId: number) => {
                const student_index = this.lesson.attending_students.indexOf(studentId);
                if (student_index !== -1) {
                    this.lesson.attending_students.splice(student_index, 1);
                    this.onSelectStudent(studentId, true);
                }
            });
            this.absentService.removedFromAbsent.subscribe((studentId: number) => {
                if (this.lesson.attending_students.indexOf(studentId) === -1) {
                    this.lesson.attending_students.push(studentId);
                }
            });
            if (this.selectedStudentIndex) {
                const studentId = this.students[this.selectedStudentIndex].id;
                this.onSelectStudent(studentId, false);
            }
        }

        this.sortingStudents();
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public sortingStudents() {
        if (this.students && this.students.length > 0) {
            return this.students.sort((a, b) => a.surname.localeCompare(b.surname));
        }
        return [];
    }

    public onSelectStudent(student_id: number, willBeAbsent: boolean): void {
        if (this.showPupilInfo === student_id) {
            this.deselectPupil();
        } else if (this.isStudentPresent(student_id)) {
            this.showPupilInfo = student_id;
            const studentIndexInList = this.students.findIndex(student => student.id === student_id);
            this.selectedStudent = this.students[studentIndexInList];
            this.selectedStudentIndex = studentIndexInList;
            smoothScrollToTop();
        }
        if (!willBeAbsent) {
            this.selectPupil.emit(this.showPupilInfo);
        }
    }

    public clickSetPrivilege(): void {
        this.setPrivilege = !this.setPrivilege;
    }

    public setActive(): any {
        if (this.setPrivilege) {
            return 'active';
        }
    }

    public definePupil(pupilId: number): void {
        this.onSelectStudent(pupilId, false);
    }

    public deselectPupil() {
        this.showPupilInfo = null;
        this.selectedStudent = null;
        this.selectedStudentIndex = null;
        this.selectPupil.emit(this.showPupilInfo);
    }

    public isStudentPresent(studentId: number): boolean {
        return this.lesson.attending_students.indexOf(studentId) !== -1;
    }
}
